<template>
    <div>
        <contact-hold-table ref="table" :url="indexUrl">
            <template v-slot:buttons>
                <button class="btn btn-purple" v-if="canCreate" @click="addContactHold">
                    <i class="far fa-file"></i>
                </button>
            </template>
        </contact-hold-table>
        <dialog-form-wrapper></dialog-form-wrapper>
    </div>
</template>

<script>
  import ContactHoldTable from '../../components/contact-hold/table';
  import eventBus from '../../event-bus';
  import DialogFormWrapper from './dialog-form-wrapper';

  export default {
    components: {
      DialogFormWrapper,
      ContactHoldTable
    },

    props: {
      indexUrl: null,
      createUrl: null,
      canCreate: {
        type: Boolean,
        default: false
      },
    },

    methods: {
      /**
       * @return {undefined}
       */
      refresh() {
        this.$refs.table.refresh();
      },
      /**
       * @event show-add-contact-hold-dialog
       */
      addContactHold() {
        eventBus.$emit('show-add-contact-hold-dialog', this.createUrl);
      },
    },

    created() {
      eventBus.$on('refresh-contact-hold-table', this.refresh);
    },

    beforeDestroy() {
      eventBus.$off('refresh-contact-hold-table', this.refresh);
    }
  }
</script>

<style scoped>

</style>
